enum Role {
	SUPER_ADMIN = 'Super Admin',
	COMPANY_ADMIN = 'Company Admin',
	SALES_MANAGER = 'Sales Manager',
	SALES_PERSON = 'Sales Person',
	USER = 'User',
}

export default Role;
